import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import Link from '../Link';
import TranslationProvider from '../../providers/TranslationProvider';
import IconBadge from '../IconBadge';
import Tooltip from '../Tooltip';

import './Badge.scss';

const Badge = ({
  id,
  label,
  onClick,
  title,
  name,
  url,
  style,
  size,
  link,
  isGda,
}) => {
  const renderBadgeContainer = () => (
    <div className="Badge__container">
      <IconBadge
        name={name}
        url={url}
        size={size}
        bgToSvgRatio="1"
      />
      {label && (
        <TranslationProvider translationKey={name}>
          <span className="Badge--label">{label}</span>
        </TranslationProvider>
      )}
    </div>
  );

  const handleClick = () => {
    onClick({
      collection: name,
      collection_id: id,
    });
  };

  const titleProp = {};
  if (!link) { titleProp.title = title; }

  return (
    <div
      className={cx('Badge', {
        [`Badge--${name}`]: !!name,
        'is-gda': isGda,
      })}
      {...titleProp}
      style={style}
    >
      {link ? (
        <Tooltip tabIndex={0} content={title || name} placement="bottom" theme="dark">
          <Link href={link} target="_self" onClick={handleClick} aria-label={title}>
            {renderBadgeContainer()}
          </Link>
        </Tooltip>
      ) : (
        <Tooltip tabIndex={0} content={title || name} placement="bottom" theme="dark">
          {renderBadgeContainer()}
        </Tooltip>
      )}
    </div>
  );
};

Badge.propTypes = {
  id: PropTypes.number.isRequired,
  label: PropTypes.string,
  onClick: PropTypes.func,
  title: PropTypes.string,
  name: PropTypes.string,
  url: PropTypes.string,
  style: PropTypes.shape({
    marginLeft: PropTypes.string,
  }),
  size: PropTypes.string,
  link: PropTypes.string,
  isGda: PropTypes.bool,
};

Badge.defaultProps = {
  label: undefined,
  onClick: () => {},
  title: '',
  name: undefined,
  url: null,
  style: { marginLeft: '0' },
  size: '22',
  link: undefined,
  isGda: false,
};

Badge.displayName = 'Badge';
export default Badge;
